import React, { useState, memo } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { ChampionshipLeague } from "../types";

const originalPath = (src) => {
	return src.replace("_DIMENSION_/", "");
};

const Avatar = ({
	photoUrl = null,
	className = "",
	size = "thumb6",
	zoom = false,
	gender = "",
	title = "",
	league = null,
	showLeagueBadge = false,
	showLeagueRing = false,
}: {
	photoUrl?: string;
	className?: string;
	size?: string;
	zoom?: boolean;
	gender?: string;
	title?: string;
	league?: ChampionshipLeague | null;
	showLeagueBadge?: boolean;
	showLeagueRing?: boolean;
}) => {
	const [isOpen, setOpen] = useState(false);

	const openLightBox = () => {
		setOpen(true);
	};

	const closeLightBox = () => {
		setOpen(false);
	};

	return photoUrl ? (
		<>
			{league && showLeagueBadge ? (
				<div className={`${zoom ? " clickable" : ""}`} onClick={zoom ? () => openLightBox() : null}>
					<svg
						width="164px"
						height="140px"
						viewBox="0 0 164 140"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g id="blank_shield" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
							<path
								d="M0.144561176,108.920779 L0.144561176,109.013168 C0.539555612,115.025614 1.74068799,120.607138 4.89917585,125.75273 C8.0488502,130.882437 13.1125496,135.51264 21.2187825,139.605185 L21.999963,140 L22.7811435,139.605185 C30.8873121,135.512678 35.9510179,130.882425 39.1007502,125.75273 C42.259238,120.607145 43.4603743,115.025595 43.8553649,109.013168 L43.8553649,108.920779 L43.9831136,89.9920237 L44,87.8858658 C29.3330542,84.1441468 14.6668814,83.9333854 0,87.8858658 L0.0168863639,89.9920237 L0.144561176,108.920779 Z"
								fill="#FFFFFF"
								fillRule="nonzero"
							></path>
						</g>
					</svg>
					<svg
						width="164px"
						height="140px"
						viewBox="0 0 164 140"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
					>
						<defs>
							<linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="playerProfileLinearGradient">
								<stop stopColor={league?.colors?.gradientStart} offset="0%"></stop>
								<stop stopColor={league?.colors?.gradientEnd} offset="100%"></stop>
							</linearGradient>
						</defs>
						<g id="ring_with_shield" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
							<path
								d="M39.1007502,125.75273 C36.0242674,130.763129 31.1217981,135.297048 23.341768,139.318789 L22.7811435,139.605185 L21.999963,140 L21.2187825,139.605185 C13.1125496,135.51264 8.0488502,130.882437 4.89917585,125.75273 C1.84597092,120.778658 0.621805943,115.397231 0.186790383,109.612976 L0.144561176,109.013168 L0.144561176,108.920779 L0.0168863639,89.9920237 L0,87.8858658 C4.644068,86.6343668 9.28806495,85.8002685 13.9320379,85.3634988 L13.6989712,85.3857526 L13.6989712,85.3857526 C12.5860197,80.4361036 12,75.2864879 12,70 C12,31.3400675 43.3400675,0 82,0 C120.659932,0 152,31.3400675 152,70 C152,108.659932 120.659932,140 82,140 C65.9158384,140 51.0986801,134.575314 39.2782963,125.455713 L39.1007502,125.75273 L39.1007502,125.75273 Z M82,3 C44.9969218,3 15,32.9969218 15,70 C15,75.2101336 15.594701,80.2813674 16.7199251,85.1495232 L16.6310198,85.1542463 C25.4872871,84.6134516 34.3435003,85.5035331 43.1999855,87.6852777 L44,87.8858658 L43.9831136,89.9920237 L43.8553649,108.920779 L43.8553649,109.013168 C43.5330625,113.919157 42.6740163,118.538262 40.6527896,122.867718 L40.7025616,122.760541 L40.7025616,122.760541 C52.0807134,131.681657 66.4192739,137 82,137 C119.003078,137 149,107.003078 149,70 C149,32.9969218 119.003078,3 82,3 Z M41.25,90.1118709 C28.4164221,86.9305007 15.5828442,86.9950842 2.75,90.1118709 C2.78974416,95.2692524 2.83023816,102.332986 2.87073215,107.490381 C3.58983577,118.968436 7.2058188,128.732437 21.9996252,136.5625 C36.793412,128.732437 40.4093752,118.968436 41.1285183,107.490381 C41.169012,102.332999 41.209506,95.2692651 41.25,90.1118709 Z M38.4062245,106.134477 C38.4027682,106.610588 38.3993206,107.068218 38.3958729,107.509641 C37.7794647,117.399906 34.6803854,126.721841 22,133.46875 C11.5396778,127.903087 7.59894189,120.585136 6.19369205,112.641361 L6.25039595,112.611216 C8.16967527,111.601953 10.1987722,110.706226 12.3380018,109.924278 C13.801776,113.838608 17.5754896,116.625 22,116.625 C27.6954365,116.625 32.3125,112.007936 32.3125,106.3125 L32.308552,106.059403 C34.451176,105.962794 36.4838056,105.987967 38.4062245,106.134477 Z M18.997385,103.30444 C20.4315375,101.870136 22.8616713,101.966785 24.4147063,103.519669 C25.7470675,104.852332 27.0083413,105.46066 28.2693125,105.375809 C28.6687638,105.34934 29.0647363,105.250271 29.4607088,105.079056 C29.5266538,105.480625 29.5625,105.892327 29.5625,106.3125 C29.5625,110.489117 26.1766175,113.875 22,113.875 C21.6380588,113.875 21.2826213,113.847926 20.9342925,113.798921 C21.0958275,113.491732 21.2136513,113.165184 21.2632613,112.813981 C21.4353838,111.593242 20.7837988,110.293097 19.2126138,108.721912 C17.65973,107.168877 17.5630813,104.738744 18.997385,103.30444 Z M22,98.75 C25.3816475,98.75 28.244205,100.969896 29.2116,104.031801 C28.869775,104.202865 28.5353613,104.297094 28.1992838,104.319327 C27.2607775,104.381491 26.2673675,103.875106 25.1632425,102.770981 C23.1975975,100.805336 20.0957625,100.708536 18.2486975,102.555752 C16.4017838,104.402817 16.4982813,107.504804 18.4639263,109.470449 C19.7622563,110.768779 20.3348888,111.814067 20.2147963,112.666059 C20.1712363,112.974306 20.041615,113.26637 19.8462,113.562064 C16.7191063,112.634296 14.4375,109.740581 14.4375,106.3125 C14.4375,102.135882 17.8233825,98.75 22,98.75 Z M38.5,92.535147 C38.4759706,95.6117334 38.4519412,99.4756161 38.4279119,103.036689 C36.3206393,102.883043 34.0995986,102.867992 31.7652439,102.988316 C30.3825655,98.9244615 26.5328051,96 22,96 C16.3045635,96 11.6875,100.617064 11.6875,106.3125 C11.6875,106.497972 11.6923963,106.6823 11.7020667,106.865363 C9.62519599,107.605289 7.64239392,108.446931 5.75245341,109.390315 C5.69206253,108.76693 5.6427429,108.139438 5.60349314,107.509641 C5.56878401,103.065683 5.53407488,96.9790941 5.5,92.535147 C16.4995864,89.8495137 27.4997932,89.7938643 38.5,92.535147 Z"
								fill="url(#playerProfileLinearGradient)"
								fillRule="nonzero"
							></path>
						</g>
					</svg>
					<div
						className={`avatar ${className}`}
						style={{ backgroundImage: `url(${photoUrl.replace("_DIMENSION_", size)})` }}
						title={title}
					/>
				</div>
			) : (
				<>
					<div
						className={`avatar ${className} ${zoom ? " clickable" : ""}`}
						style={{ backgroundImage: `url(${photoUrl.replace("_DIMENSION_", size)})` }}
						onClick={zoom ? () => openLightBox() : null}
						title={title}
					/>
					{league && showLeagueRing ? (
						<div
							className="ring"
							style={{
								background: `linear-gradient(${league?.colors?.gradientStart}, ${league?.colors?.gradientEnd})`,
							}}
						/>
					) : null}
				</>
			)}
			{isOpen ? (
				<Lightbox mainSrc={originalPath(photoUrl)} onCloseRequest={closeLightBox} enableZoom={false} />
			) : null}
		</>
	) : (
		<div className={`avatar default ${className} ${gender}`} />
	);
};

export default memo(Avatar);
